/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-return-assign */
import { Box, Flex, FormControl, HStack, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaArrowLeft, FaArrowRight, FaChevronLeft, FaFileCsv } from 'react-icons/fa'
import { IoMailSharp } from 'react-icons/io5'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { ImgSah } from '../../../../components/ImgSah'
import { InputCmp } from '../../../../components/InputCmp'
import LoadingContainer from '../../../../components/LoadingContainer'
import { SelectCmp } from '../../../../components/SelectCmp'
import { iNomeId } from '../../../../interfaces'
import { appApi, urlApi } from '../../../../services/appApi'
import { parseJwt } from '../../../../services/token'
import { PropInvalida, useQuery, ObterToken } from '../../../../Utils/Helper'
import { numberFormatter } from '../../../AssessmentPI/Dashboard'
import { Body } from '../../../Layouts/Body'
import { ENPS } from '../Formulario/Components/Questao/Components/eNPS'
import { BarChart } from './Components/BarChart'
import { CaixaDeSelecao } from './Components/CaixaDeSelecao'
import { ColumnChart } from './Components/ColumnChart'
import { IStackedColumnChartData, StackedColumnChart } from './Components/ColumnStacked'
import { Discursiva } from './Components/Discursiva'
import { Escala } from './Components/Escala'
import { MultiplaEscolha } from './Components/MultiplaEscolha'
import { PieChart } from './Components/PieChart'
import { PieChartENPS } from './Components/PieChartENPS'
import { TabelaCiclica } from './Components/TabelaCiclica/TabelaCiclica'
import { ComentariosContainer } from './styles'

interface iDiscursiva {
  pergunta: string
  respostas: string[]
}

interface iPieChartData {
  nome: string
  series: string[]
  labels: string[]
  tipo?: number
  respostas: number
  media?: number
}

interface ieNPSs{
  detratores: number
  enunciado: string
  neutros: number
  promotores: number
  resultadoEnps: string
  total: number
}

export interface iResultadoPesquisaInterna {
  discursivas: iDiscursiva[]
  nome: string
  descricao: string
  encerrada: boolean
  isCiclica: boolean
  isAnonima: boolean
  graficos: iPieChartData[]
  graficosCiclica: IStackedColumnChartData[]
  responseIndividuaisCiclicas: iResponseIndividualCiclica[]
  escalas: iPieChartData[]
  respostaIndividual: iRespostaIndividual[]
  filtroColaboradores: iNomeId[]
  filtroRespostas: iNomeId[]
  eNPSs: ieNPSs[]
}

export interface iResponseIndividualCiclica {
  graficosIndividuais: IStackedColumnChartData[]
  respondente: string
}

interface iRespostaIndividual {
  respondente: string
  respostas: iRespostaQuestao[]
}

interface iRespostaQuestao {
  enunciado: string
  tipo: number
  alternativaResposta: string[]
}

export const ResultadoPesquisaInterna: React.FC = () => {
  const { pesquisaId } = useParams<{ pesquisaId: string }>()
  const query = useQuery()
  const queryParams: { feedbackId?: string } = Object.fromEntries(new URLSearchParams(window.location.search).entries())
  const { pathname } = useLocation()
  const nav = useNavigate()
  const [Model, setModel] = useState<iResultadoPesquisaInterna>()
  const [ColabordorId, setColabordorId] = useState('')
  const [DataInicio, setDataInicio] = useState('')
  const [DataFim, setDataFim] = useState('')
  const [RespostaId, setRespostaId] = useState('')
  const [IsLoading, setIsLoading] = useState(false)
  const [SelectedIndividual, setSelectedIndividual] = useState(1)

  const colorsGrafico = [
    '#2E93fA',
    '#66DA26',
    '#FF9800',
    '#FF5CAD',
    '#E91E63',
    '#775DD0',
    '#F9CE1D',
    '#009688',
    '#FF4560',
    '#546E7A'
  ]

  function PrevPage(isClicica: boolean): void {
    if (SelectedIndividual !== 1) {
      setSelectedIndividual(SelectedIndividual - 1)
    } else {
      setSelectedIndividual((isClicica ? Model?.responseIndividuaisCiclicas.length : Model?.respostaIndividual.length) ?? 0)
    }
  }

  function NextPage(isClicica: boolean): void {
    if (SelectedIndividual < ((isClicica ? Model?.responseIndividuaisCiclicas.length : Model?.respostaIndividual.length) ?? 0)) {
      setSelectedIndividual(SelectedIndividual + 1)
    } else {
      setSelectedIndividual(1)
    }
  }

  function Resultado(): void {
    appApi.get(`PesquisaInterna/Resultado/${pesquisaId as string}?feedbackId=${queryParams.feedbackId ?? ''}`)
      .then(res => {
        if (res.status === 200) {
          setModel(res.data)
        }
      })
      .catch(err => console.log(err))
  }

  function FiltrarResultado(id: string, dataInicio: string, dataFim: string): void {
    setIsLoading(true)
    setRespostaId('')
    appApi.get(`PesquisaInterna/Resultado/${pesquisaId as string}?colaboradorId=${id}&dataInicio=${dataInicio}&dataFim=${dataFim}`)
      .then(res => {
        setModel(undefined)
        setModel(res.data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function FiltrarResultadoResposta(id: string): void {
    setIsLoading(true)
    setColabordorId('')
    appApi.get(`PesquisaInterna/Resultado/${pesquisaId as string}?respostaId=${id}`)
      .then(res => {
        setModel(undefined)
        setModel(res.data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function ReturnCiclicaGraficos(idGrafico: string, isIndividual: boolean, data?: IStackedColumnChartData[], hiddenRespostas?: boolean): any {
    if (!data || data.length === 0) return null

    return data.map((e, i) => {
      return <Flex key={i} flexDir={'column'} width='100%' pt={'2rem'} pb={'1rem'} borderBottom={i === data.length - 1 ? '' : '1px solid var(--c5)'}>
        <Flex flexDir={'column'}>
          <Text fontSize={'1rem'}><strong style={{ fontWeight: 900 }}>{i + 1}</strong> - {e.questao}</Text>
          {!hiddenRespostas && <Text fontSize={'.813rem'} color={'var(--Gray3)'} ml={'.25rem'} fontWeight={'400'}>Respostas: {e.qtdRespostasTotal}</Text>}
        </Flex>
        <Flex justifyContent={'center'} alignItems={'center'} width={'100%'} paddingBottom={'1rem'} marginBottom={'1rem'} flexDir={'column'} gap={'1rem'}>
          {!isIndividual && <>
            {e.seriesEscala.length === 0 && <StackedColumnChart data={e} id={`${idGrafico}-chart-${i}`} />}
            {e.seriesEscala.length !== 0 && <ColumnChart data={e} id={`${idGrafico}-chart-${i}`} />}
          </>}
          <TabelaCiclica data={e}/>
        </Flex>
      </Flex>
    })
  }

  function RenderENPS(prefixoDeRenderizacao: string): JSX.Element | null {
    if (!Model?.eNPSs || Model.eNPSs.length === 0) return null

    return (
    <Flex flexDir={'column'}>
      {Model.eNPSs.map((item, i) => (
        <Box
          paddingTop={i !== 0 ? '1.5rem' : ''}
          paddingBottom={i === Model.eNPSs.length - 1 ? '' : '1rem'}
          borderBottom={i === Model.eNPSs.length - 1 ? '' : '2px solid var(--c5)'}
          key={i}
          gap={'2rem'}
        >
          <Flex ml={'0rem'} fontSize={'.925rem'}>
              <Text as={'h3'} fontWeight={'bold'}>{i + 1} - {item.enunciado}</Text>
          </Flex>

          <Flex ml={'18rem'} mt={'30px'} mb={'2rem'}>
            <Flex flexDirection={'column'} mt={'1rem'}>
              <Flex alignItems={'center'} gap={'.325rem'}>
                <Text fontWeight={'bold'}>Promotores:</Text>
                <Flex
                  alignItems="center"
                  justifyContent="center"
                  width="30px"
                  height="30px"
                  borderRadius="50%"
                  background="green.400"
                  color="#ffffffff"
                  fontSize=".813rem"
                  fontWeight="600"
                >
                  <strong>{item.promotores ?? 0}</strong>
                </Flex>
              </Flex>

              <Flex alignItems={'center'} gap={'.325rem'} mt={'6px'}>
                <Text fontWeight={'bold'}>Neutros:</Text>
                <Flex
                  alignItems="center"
                  justifyContent="center"
                  width="30px"
                  height="30px"
                  borderRadius="50%"
                  background="yellow.400"
                  color="#ffffffff"
                  fontSize=".813rem"
                  fontWeight="600"
                >
                  <strong>{item.neutros ?? 0}</strong>
                </Flex>
              </Flex>

              <Flex alignItems={'center'} gap={'.325rem'} mt={'6px'}>
                <Text fontWeight={'bold'}>Detratores:</Text>
                <Flex
                  alignItems="center"
                  justifyContent="center"
                  width="30px"
                  height="30px"
                  borderRadius="50%"
                  background="red.400"
                  color="#ffffffff"
                  fontSize=".813rem"
                  fontWeight="600"
                >
                  <strong>{item.detratores ?? 0}</strong>
                </Flex>
              </Flex>
            </Flex>

            <PieChartENPS
              id={`${prefixoDeRenderizacao}-enps-chart-${i}`}
              promotores={item.promotores}
              neutros={item.neutros}
              detratores={item.detratores}
              nps={item.resultadoEnps}
              total={item.total}
            />

            <Flex justifyContent={'space-between'} alignItems={'center'} mb={'6rem'}>
              <Flex alignItems={'center'} gap={'.325rem'}>
                <Text fontWeight={'bold'}>Total de respostas:</Text>
                <Flex
                  alignItems="center"
                  justifyContent="center"
                  width="30px"
                  height="30px"
                  borderRadius="50%"
                  background="blue.300"
                  color="#ffffffff"
                  fontSize=".813rem"
                  fontWeight="600"
                >
                  <strong>{item.total ?? 0}</strong>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </Box>
      ))}
    </Flex>
    )
  }

  useEffect(() => {
    const id = query.get('colaboradorId')
    if (!PropInvalida(id)) {
      setColabordorId(id ?? '')
      FiltrarResultado(id ?? '', DataInicio ?? '', DataFim ?? '')
    } else {
      Resultado()
    }
  }, [])

  return (
    <Body>
      <Flex justifyContent={'space-between'} margin={'1rem 0 1.5rem 0'}>
        <Flex flexDir={'column'}>
          <h1>{Model?.nome}</h1>
          <span>{Model?.descricao}</span>
        </Flex>
        <Flex gap={'.5rem'}>
          <ButtonCmp onClick={() => nav(-1)} VarColor="c6" leftIcon={<FaChevronLeft/>}>Voltar</ButtonCmp>
          {parseJwt().adm === 'True' &&
            <Flex gap={'.5rem'}>
              <ButtonCmp
                VarColor='Rosa'
                onClick={() => window.location.href = `${urlApi}/PesquisaInterna/Csv?pesquisaId=${pesquisaId as string}&token=${ObterToken()}&feedbackId=${queryParams.feedbackId ?? ''}`}
                leftIcon={<FaFileCsv />}>
                Baixar base
              </ButtonCmp>
              {!Model?.encerrada &&
                <ButtonCmp
                  VarColor='Green2'
                  leftIcon={<IoMailSharp />}
                  onClick={() => nav(pathname.replace('Resultado', 'Convites'))}
                  >Gestão de convites
                </ButtonCmp>
              }

            </Flex>
          }
        </Flex>
      </Flex>
      <Flex gap={'1.325rem'} marginBottom={'.875rem'}>
        {
          (Model?.filtroRespostas && Model?.filtroRespostas?.length > 0) && (
            <FormControl width={'18rem'}>
              <SelectCmp value={RespostaId} title='Filtrar por resposta objetiva' OnChange={(e) => {
                FiltrarResultadoResposta(e)
                setRespostaId(e)
              }} borderColor={'var(--Gray4)'}>
                <option value={''}>Todos</option>
                {
                  Model?.filtroRespostas.map((e) => {
                    return (
                      <option key={e.id} value={e.id}>{e.nome}</option>
                    )
                  })
                }
              </SelectCmp>
            </FormControl>
          )}

        {
          (Model?.filtroColaboradores && Model?.filtroColaboradores?.length > 0 && !Model?.isAnonima) && (
            <FormControl width={'18rem'}>
              <SelectCmp title='Colaborador' value={ColabordorId} OnChange={(e) => {
                FiltrarResultado(e, DataInicio ?? '', DataFim ?? '')
                setColabordorId(e)
              }} borderColor={'var(--Gray4)'}>
                <option value={''}>Todos</option>
                {
                  Model?.filtroColaboradores.map((e) => {
                    return (
                      <option key={e.id} value={e.id}>{e.nome}</option>
                    )
                  })
                }
              </SelectCmp>
            </FormControl>
          )
        }
        {(Model?.isCiclica) && (
          <>
            <FormControl width={'14rem'}>
              <InputCmp type={'date'} label='Data início' value={DataInicio} OnChange={(e) => {
                FiltrarResultado(ColabordorId ?? '', e, DataFim ?? '')
                setDataInicio(e)
              }} borderColor={'var(--Gray4)'}/>
            </FormControl>
            <FormControl width={'14rem'}>
              <InputCmp type={'date'} label='Data fim' value={DataFim} OnChange={(e) => {
                FiltrarResultado(ColabordorId ?? '', DataInicio ?? '', e)
                setDataFim(e)
              }} borderColor={'var(--Gray4)'}/>
            </FormControl>
          </>
        )}
      </Flex>
      <LoadingContainer loading={IsLoading} linhas={22}>
        <Tabs variant='unstyled'>
          <TabList marginBottom={'.01rem'}>
            {(((Model?.graficos.length || Model?.graficosCiclica.length || 0) > 0) || (Model?.eNPSs.length ?? 0) > 0) &&
              <Tab backgroundColor={'white'} color={'var(--c6)'} borderRadius={'.25rem 0 0 0'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>Resultados</Tab>
            }
            {(Model?.respostaIndividual.length || Model?.responseIndividuaisCiclicas.length || 0) > 0 &&
              <Tab backgroundColor={'white'} color={'var(--c6)'} borderRadius={'0'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>Individual</Tab>
            }
            {Model?.escalas && (Model?.escalas.length > 0) && (
              <Tab backgroundColor={'white'} color={'var(--c6)'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>Escalas</Tab>
            )}
            {(Model?.discursivas.length ?? 0) > 0 && (
              <Tab backgroundColor={'white'} color={'var(--c6)'} borderRadius={'0 .25rem 0 0'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>Questões discursivas</Tab>
            )}
            {(Model?.eNPSs.length ?? 0) > 0 && (
              <Tab backgroundColor={'white'} color={'var(--c6)'} borderRadius={'0 .25rem 0 0'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>eNPS</Tab>
            )}
          </TabList>
          <TabPanels boxShadow={'var(--SombraBackground)'} background={'var(--c1)'} padding={'1rem 2rem'}>
            {(((Model?.graficos.length || Model?.graficosCiclica.length || 0) > 0) || (Model?.eNPSs.length ?? 0) > 0) && (
              <TabPanel>
                <Flex flexDir={'column'}>
                  {Model?.graficos.map((e, i) => {
                    if ((e.series.length <= 8 && e.tipo !== 5) || ColabordorId.length > 3) {
                      return (
                        <Flex key={i} flexDir={'column'} width='100%' pt={'2rem'} pb={'1rem'} borderBottom={i === Model?.graficos.length - 1 ? '' : '1px solid var(--c5)'}>
                          <Flex justifyContent={'space-between'} alignItems={'center'}>
                            <Flex flexDir={'column'}>
                              <Text fontSize={'1rem'}><strong style={{ fontWeight: 900 }}>{i + 1}</strong> - {e.nome}</Text>
                              <Text fontSize={'.813rem'} color={'var(--Gray3)'} ml={'.25rem'} fontWeight={'400'}>Respostas: {e.respostas}</Text>
                            </Flex>
                            {e.media && <Flex alignItems={'center'} justifyContent={'center'} p={'.625rem 1.25rem'} color={'var(--c1)'} bg={'var(--Azul)'} gap={'.325rem'} fontSize={'.875rem'} borderRadius={'.125rem'}>Média: <strong>{e.media.toFixed(2)}</strong></Flex>}
                          </Flex>
                          <Flex pt={'3rem'} justifyContent={'center'} alignItems={'center'} width={'100%'} paddingBottom={'1rem'} marginBottom={'1rem'} gap={'.5rem'}>
                            <PieChart data={e} id={`chart-${i}`} colorsGrafico={colorsGrafico}/>
                            <Flex flexDir={'column'} gap={'.325rem'}>
                              {e.labels.map((label, indexLabel) => {
                                return <Flex gap={'.5rem'} alignItems={'center'} fontSize='14px' fontWeight={400}>
                                  <Flex borderRadius={'50%'} w={'.875rem'} h={'.875rem'} bg={colorsGrafico[indexLabel]}></Flex>
                                  {label}
                                </Flex>
                              })}
                            </Flex>
                          </Flex>
                        </Flex>
                      )
                    } else {
                      return (
                        <Flex key={i} flexDir={'column'} width='100%' pt={'2rem'} pb={'1rem'} borderBottom={i === Model?.graficos.length - 1 ? '' : '1px solid var(--c5)'}>
                          <Flex flexDir={'column'}>
                            <Text fontSize={'1rem'}><strong style={{ fontWeight: 900 }}>{i + 1}</strong> - {e.nome}</Text>
                            <Text fontSize={'.813rem'} color={'var(--Gray3)'} ml={'.25rem'} fontWeight={'400'}>Respostas: {e.respostas}</Text>
                          </Flex>
                          <Flex justifyContent={'center'} alignItems={'center'} width={'100%'} paddingBottom={'1rem'} marginBottom={'1rem'}>
                            <BarChart data={e} id={`chart-${i}`} />
                          </Flex>
                        </Flex>
                      )
                    }
                  })
                  }
                  {(Model?.graficos.length || Model?.graficosCiclica.length || 0) > 0 && (
                    <>
                    {ReturnCiclicaGraficos('graficos-visao-geral', false, Model?.graficosCiclica)}
                    </>
                  )}
                  {(Model?.eNPSs.length ?? 0) > 0 && (
                    <>
                    <Text as={'h1'} mb={'1rem'}>eNPS</Text>
                    {RenderENPS('graficos-enps')}
                    </>
                  )}
                </Flex>
              </TabPanel>
            )}
            {(Model?.respostaIndividual.length || Model?.responseIndividuaisCiclicas.length || 0) > 0 && (
              <TabPanel>
                {(Model?.respostaIndividual.length ?? 0) > 0 && <Flex justifyContent={'space-between'} mb={'1rem'}>
                  <Text fontSize={'.875rem'}>Respondente: <strong>{Model?.respostaIndividual[SelectedIndividual - 1].respondente}</strong></Text>
                  <HStack mt={0} p={'.25rem'} fontSize={'.875rem'}>
                    <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => PrevPage(false)} VarColor='Green2'><FaArrowLeft/></ButtonCmp>
                    <Text>{numberFormatter.format(SelectedIndividual)} / {Model?.respostaIndividual.length}</Text>
                    <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => NextPage(false)} VarColor='Green2'><FaArrowRight/></ButtonCmp>
                  </HStack>
                </Flex>}
                {(Model?.responseIndividuaisCiclicas.length ?? 0) > 0 && <Flex justifyContent={'space-between'} mb={'1rem'}>
                  <Text fontSize={'.875rem'}>Respondente: <strong>{Model?.responseIndividuaisCiclicas[SelectedIndividual - 1].respondente}</strong></Text>
                  <HStack mt={0} p={'.25rem'} fontSize={'.875rem'}>
                    <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => PrevPage(true)} VarColor='Green2'><FaArrowLeft/></ButtonCmp>
                    <Text>{numberFormatter.format(SelectedIndividual)} / {Model?.responseIndividuaisCiclicas.length}</Text>
                    <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => NextPage(true)} VarColor='Green2'><FaArrowRight/></ButtonCmp>
                  </HStack>
                </Flex>}
                <Flex flexDir={'column'}>
                  {
                    (Model?.respostaIndividual.length ?? 0) > 0 && Model?.respostaIndividual[SelectedIndividual - 1]?.respostas.map((e, i) => {
                      if (e.tipo === 0) {
                        return (
                          <MultiplaEscolha
                            key={i}
                            questao={e}
                          />
                        )
                      } else if (e.tipo === 5) {
                        return (
                          <CaixaDeSelecao
                            key={i}
                            questao={e}
                          />
                        )
                      } else if (e.tipo === 1) {
                        return (
                          <Discursiva
                            key={i}
                            questao={e}
                          />
                        )
                      } else if (e.tipo === 6) {
                        return (
                          <Escala
                            key={i}
                            questao={e}
                          />
                        )
                      } else if (e.tipo === 4) {
                        return (
                          <Flex flexDir={'column'} mb={'2rem'} key={i}>
                            <Text mb={'10px'} fontWeight={'bold'}>{e.enunciado}</Text>
                            <ENPS questao={e} />
                            <br />
                            <hr />
                          </Flex>
                        )
                      }
                      return null
                    })
                  }
                  {(Model?.responseIndividuaisCiclicas.length ?? 0) > 0 && ReturnCiclicaGraficos('graficos-individuais', true, Model?.responseIndividuaisCiclicas[SelectedIndividual - 1].graficosIndividuais ?? [], true)}
                </Flex>
              </TabPanel>
            )}
            {Model?.escalas && (Model?.escalas?.length > 0) && (
              <TabPanel>
                <Flex flexDir={'column'}>
                  {Model?.escalas.map((e, i) => {
                    return (
                      <Flex key={i} flexDir={'column'} width='100%' pt={'2rem'} pb={'1rem'} borderBottom={i === Model?.escalas.length - 1 ? '' : '1px solid var(--c5)'}>
                        <Flex justifyContent={'space-between'} alignItems={'center'}>
                          <Flex flexDir={'column'} mb={'1rem'}>
                            <Text fontSize={'1rem'}><strong style={{ fontWeight: 900 }}>{i + 1}</strong> - {e.nome}</Text>
                            <Text fontSize={'.813rem'} color={'var(--Gray3)'} ml={'.25rem'} fontWeight={'400'}>Respostas: {e.respostas}</Text>
                          </Flex>
                          {e.media ? <Flex alignItems={'center'} justifyContent={'center'} p={'.625rem 1.25rem'} color={'var(--c1)'} bg={'var(--Azul)'} gap={'.325rem'} fontSize={'.875rem'} borderRadius={'.125rem'}>Média Geral: <strong>{e.media.toFixed(2)}</strong></Flex> : <></>}
                        </Flex>
                        <Flex justifyContent={'center'} alignItems={'center'} width={'100%'} paddingBottom={'1rem'} marginBottom={'1rem'}>
                          <BarChart data={e} id={`escala-chart-${i}`} />
                        </Flex>
                      </Flex>
                    )
                  })}
                </Flex>
              </TabPanel>
            )}

            {(Model?.discursivas.length ?? 0) > 0 && (
              <TabPanel>
                {
                  Model?.discursivas.map((e, i) => {
                    return (
                      <Box paddingTop={i !== 0 ? '1.5rem' : ''} paddingBottom={i === Model?.discursivas.length - 1 ? '' : '1rem'} borderBottom={i === Model?.discursivas.length - 1 ? '' : '2px solid var(--c5)'} key={i}>
                        <Flex justifyContent={'space-between'} alignItems={'center'}>
                          <Flex gap={'.325rem'} fontSize={'.925rem'}>
                            <Text fontWeight={'400'}>Pergunta:</Text>
                            <Text
                              fontWeight={'700'}
                            >{e.pergunta}</Text>
                          </Flex>
                          <Flex alignItems={'center'} gap={'.325rem'} justifyContent={'center'} border={'2px solid var(--Azul)'} p={'.25rem 1rem'} fontSize={'.813rem'} borderRadius={'.25rem'}>
                            Comentários: <strong>{e.respostas.length}</strong>
                          </Flex>
                        </Flex>
                        <ComentariosContainer>
                          <section>
                            {
                              e.respostas.map((e, i) => {
                                return (
                                  <div key={i}>
                                    <span key={i}>{e}</span>
                                  </div>
                                )
                              })
                            }
                          </section>
                        </ComentariosContainer>
                      </Box>
                    )
                  })
                }
              </TabPanel>
            )}
            {(Model?.eNPSs.length ?? 0) > 0 && (

              <TabPanel>
                <Flex flexDir={'column'}>
                  {RenderENPS('tab-enps')}
                </Flex>
              </TabPanel>

            )}
            {Model?.graficos.length === 0 && Model.graficosCiclica.length === 0 && Model.eNPSs.length === 0 && <ImgSah textoPersonalizado='Nenhum resultado foi encontrado'/>}
          </TabPanels>
        </Tabs>
      </LoadingContainer>
    </Body>
  )
}
